<template>
  <van-overlay :show="show" >
    <div class="wrapper" @click.stop>
      <div class="block" >
        <h1>请选择</h1>
        <van-button type="primary" @click="handleCopyloan" color="#0294FF" round block>此订单再次申请</van-button>
        <van-button type="primary" color="#0294FF" @click="handleRouterLoan" plain round block>重新填写资料申请</van-button>
      </div>
      <div class="close-icon" @click="closeModal"><van-icon  name="cross" color="#fff"/></div>
    </div>
  </van-overlay>
</template>
<script>
import { Button, Overlay, Icon, Toast } from 'vant';
import { mapActions } from 'vuex';
export default {
  name: 'OverlayModal',
  data() {
    return {
    }
  },
  props: {
    show: Boolean,
    channel_lable: String,
    id: String
  },
  methods: {
    ...mapActions(['commitData']),
    closeModal() {
      this.$emit('closeModal', false)
    },
    handleCopyloan() {
      Toast.loading({
        message: '加载中...',
        forbidClick: true,
        loadingType: 'spinner',
      });
      this.commitData({
        request: 'loan/copyloan',
        path: 'loan/copyloan',
        data: {
          id: this.id,
          channel_id: this.channel_lable
        },
        onSuccess: (res) => {
          // const channel_lable = this.channel_lable
          // this.$router.push('/applysuccess?channel_lable='+channel_lable)
          this.handleCheckManagers(res.info)
        },
        onFail: (err) => {
          this.$toast(err.msg)
        }
      })
    },
    handleCheckManagers(data) {
      data['channel_id'] = this.channel_lable
      Toast.loading({
        message: '加载中...',
        forbidClick: true,
        loadingType: 'spinner',
      });
      this.commitData({
        request: 'loan/addinfo',
        path: 'loan/addinfo',
        data: data,
        onSuccess: () => {
         
          this.$router.push('/applysuccess?type=order&channel_lable='+ this.channel_lable)
        },
        onFail: (err) => {
          this.$toast(err.msg)
        }
      });
    },
    handleRouterLoan() {
      this.$router.push('/loan?channel_lable='+ this.channel_lable + '&is_copy=' + this.id)
    },
    conversion() {
      countLog.ready(function() { 
        countLog.init(function() {
        // 如果需要跳转，在此处写入 window.location.href = 跳转链接 
        }, {
          // 是否需要复制订单号，是为 1，不是为 0 
          isCopy: 0, 
          // 上报转化类型，具体见下表 
          pageType: 0 
      })})
    }
  },
  components: {
    [Button.name]: Button,
    [Overlay.name]: Overlay,
    [Icon.name]: Icon
  }
}
</script>